import LicenseNotification from './LicenseNotification';

export default LicenseNotification;
